const tableHeaders = [
  {
    label: 'date',
    key: 'updatedAt',
    filter: 'date',
    defaultSort: true,
    sortReverse: 'desc',
  },
  {
    label: 'type',
    key: 'archiveType',
    defaultSort: true,
  },
  {
    label: 'name',
    key: 'archiveName',
    defaultSort: true,
  },
  {
    label: 'view',
    key: 'action',
    defaultSort: true,
  },
];

export default () => tableHeaders;
